import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        remRatio:0,
        updateRemRatio:0,

        headerIdStr:null,
        headerUpdate:0,
        headerLogo:'',
        sideBarShow:false,
        userData:{
            version:'0',
            username:'',
            Id:'',
            role:'',
            lastLoginTime:'2018-12-22 13:30:21',
            client_key:'',
            token:'',
            number:'',
            avatar:'',
        },

        linkToType:'/home',

        scrollType:'',
        lastScrollTop:'',
        
        bannerLeft:0,
        devInfoImgList: [],
    },
    getters: {
        bannerLeft:state=>state.bannerLeft,
        
        devInfoImgList:state=>state.devInfoImgList,

        linkToType:state=>state.linkToType,

        remRatio:state=>state.remRatio,

        headerLogo:state=>state.headerLogo,
        sideBarShow:state=>state.sideBarShow,



        headerIdStr:state=>state.headerIdStr,
        headerUpdate:state=>state.headerUpdate,
        updateRemRatio:state=>state.updateRemRatio,

        version:state=>state.userData.version,
        username:state=>state.userData.username,
        id:state=>state.userData.id,
        role:state=>state.userData.role,
        lastLoginTime:state=>state.userData.lastLoginTime,
        client_key:state=>state.userData.client_key,
        token:state=>state.userData.token,
        number:state=>state.userData.number,
        avatar:state=>state.userData.avatar,

        
        scrollType:state=>state.scrollType,
        lastScrollTop:state=>state.lastScrollTop,
        
    },
    actions: {

    },
    mutations: {
        bannerLeftFun(state,payload){
            state.bannerLeft = payload.bannerLeft;
        },
        devInfoImgListFun(state,payload){
            state.devInfoImgList = payload.devInfoImgList;
        },
        scrollTypeFun(state,payload){
            state.scrollType = payload.scrollType;
        },
        lastScrollTopFun(state,payload){
            state.lastScrollTop = payload.lastScrollTop;
        },
        
        HEADERLOGO(state,payload){
            state.headerLogo = payload.headerLogo;
        },
        SIDEBARSHOW(state,payload){
            state.sideBarShow = payload.sideBarShow;
        },
        USERDATAFUN:(state,payload)=>{
            state.userData.version = payload.version;
            state.userData.username = payload.username;
            state.userData.id = payload.id;
            state.userData.role = payload.role;
            state.userData.lastLoginTime = payload.lastLoginTime;
            state.userData.client_key = payload.client_key;
            state.userData.token = payload.token;
            state.userData.number = payload.number;
            state.userData.avatar = payload.avatar;
        },
        VERSION:(state,payload)=>{
            state.userData.version = payload.version;
        },

        UPDATEREMRATIOFUN:(state,payload)=>{
            state.updateRemRatio = payload.updateRemRatio;
        },

        linkToTypeFun:(state,payload)=>{
            state.linkToType = payload.linkToType;
        },
        
        REMRATIOFUN:(state,payload)=>{
            state.remRatio = payload.remRatio;
        },
    },
})
